export default () => {
  const customDropdowns = document.querySelectorAll('.custom-dropdown');
  const allTabs = document.querySelectorAll('.tabs__body__content');

  if (customDropdowns) {
    customDropdowns.forEach(function(dropdown){
      const dropdownHeader = dropdown.querySelector('.dropdown-header');
      const dropdownOptions = dropdown.querySelector('.dropdown-options');

      const defaultOption = dropdownOptions.querySelector('.dropdown-option');
      dropdownHeader.textContent = defaultOption.textContent;
      defaultOption.classList.add('selected');

      dropdown.addEventListener("click", function(event) {
        event.stopPropagation();
        closeAllDropdownsExcept(this);
        dropdownOptions.classList.toggle('open');
      });

      dropdown.querySelectorAll('.dropdown-option').forEach(function(option) {
        option.addEventListener('click', function() {
          const selectedOption = this.textContent;
          dropdownHeader.textContent = selectedOption;
          dropdownOptions.querySelectorAll('.dropdown-option').forEach(function(opt) {
            opt.classList.remove('selected');
          });
          this.classList.add('selected');
          setTimeout(function() {
            dropdownOptions.classList.remove('open');
          }, 50);

          if(allTabs) {
            const tabId = this.getAttribute('data-tab');
            const relatedTab = document.getElementById(tabId);
            allTabs.forEach(tab => tab.classList.remove('active'));
            relatedTab.classList.add('active');
          }

        });
      });
    });

    document.addEventListener("click", function(event) {
      customDropdowns.forEach(function(dropdown) {
        if (!dropdown.contains(event.target)) {
          const dropdownOptions = dropdown.querySelector('.dropdown-options');
          dropdownOptions.classList.remove('open');
        }
      });
    });
  }

  function closeAllDropdownsExcept(clickedDropdown) {
    customDropdowns.forEach(function(dropdown) {
      if (dropdown !== clickedDropdown) {
        const dropdownOptions = dropdown.querySelector('.dropdown-options');
        dropdownOptions.classList.remove('open');
      }
    });
  }
}
